<template>
  <div>
    <template v-if="subitem?.isExpectedDocument">
      <div v-if="isStipulationStatus(subitem, StipulationStatusIds.OPEN) && showSampleDocument">
        <a target="_blank" :href="sampleDocumentCdnUrl">See sample here</a>
      </div>
      <p v-if="isStipulationStatus(subitem, StipulationStatusIds.OPEN)">
        {{ subitem.stipulationText }}
      </p>
      <p v-if="isStipulationStatus(subitem, StipulationStatusIds.PENDING)">
        Your submission has been received and is awaiting review. This status will update once the
        review is complete.
      </p>
    </template>
    <template v-else>
      <p v-if="hideStipTextStips.includes(subitem.stipulationTypeId)"></p>
      <p v-else-if="isCreditBureauAction && stipulationText">
        {{ stipulationText.split(`${tollFreeNumber}`)?.[0] }}&nbsp;<a :href="`tel:${hrefTFN}`"
          >&nbsp;{{ tollFreeNumber }}&nbsp;</a
        >{{ stipulationText.split(`${tollFreeNumber}`)?.[1] }}
      </p>
      <EstablishMembership
        v-else-if="
          isStipulationType(subitem, MembershipStipulationTypeIds.EstablishMembership) &&
          isStipulationStatus(subitem, StipulationStatusIds.OPEN)
        "
        :text="subitem.stipulationText"
        :lenderName="lenderData?.name"
      />
      <NonIncomeResponsibleApplicant
        v-else-if="
          isStipulationType(subitem, IncomeStipulationTypeIds.NonIncomeResponsibleApplicant)
        "
				:stip="subitem"
        @click="handleClick"
      />
      <p
        v-else-if="htmlStipTextStips.includes(subitem?.stipulationTypeId)"
        ref="htmlRef"
        v-html="DOMPurify.sanitize(subitem.stipulationText)"
      ></p>
      <p v-else-if="isStipulationStatus(subitem, StipulationStatusIds.PENDING)">
        Verification Pending
      </p>
      <p v-else>{{ subitem.stipulationText }}</p>
    </template>
  </div>
</template>
<script setup lang="ts">
import { withDefaults, defineProps, computed, ref } from "vue";
import { useStore } from "vuex";
import { IncomeStipulationTypeIds } from "@/config/constants";
import DOMPurify from "dompurify";
import NonIncomeResponsibleApplicant from "@/components/checklist/stipulation-texts/NonIncomeResponsibleApplicant.vue";
import EstablishMembership from "@/components/checklist/stipulation-texts/EstablishMembership.vue";
import {
  isStipulationStatus,
  isStipulationType,
  useStipulation,
} from "@/composables/stipulations/useStipulation";
import { MembershipStipulationTypeIds } from "@/config/constants";
import { Stipulation } from "@/models/opal";
import { StipulationStatusIds } from "@/config/constants";

interface Props {
  subitem: Stipulation;
}

const store = useStore();

const props = withDefaults(defineProps<Props>(), {});

const htmlRef = ref<HTMLElement | HTMLAnchorElement | HTMLDivElement | null>();

const stipulation = computed<Stipulation>(() => props.subitem);

const {
  isCreditBureauAction,
  tollFreeNumber,
  hrefTFN,
  emailAddress,
  stipulationText,
  showSampleDocument,
  sampleDocumentCdnUrl,
  hideStipTextStips,
  htmlStipTextStipsWithMergeFields,
  htmlStipTextStips,
  lenderData,
  configuration,
} = useStipulation(stipulation);

function handleClick() {
  //#TODO
  console.log("handleClickHere");

  // Get latest stips after
}
</script>
<style scoped>
a {
  color: gray;
  text-decoration: underline;
  cursor: pointer;
}
</style>
